import { type Html, html, UnsafeHtml, View } from 'rune-ts';
import klass from './CreatorNameView.module.scss';
import { IconBasicGuarantee } from '@services/MarppleShop/shared/components/atoms/Icon';

export interface CreatorNameViewData {
  is_partner: boolean;
  name: string | Html | UnsafeHtml;
  size: 'xSmall' | 'small' | 'medium' | 'large' | 'xLarge' /* 14 | 16 | 20 | 24 | 28px */;
  clickable?: boolean;
}

export class CreatorNameView extends View<CreatorNameViewData> {
  static sizeOption = {
    xSmall: klass.xSmall,
    small: klass.small,
    medium: klass.medium,
    large: klass.large,
    xLarge: klass.xLarge,
  };

  override template() {
    return html`<div class="${klass.guarantee}  ${CreatorNameView.sizeOption[this.data.size]}">
      <div class="${klass.name}">${this.data.name}</div>
      <div class="${klass.svg} ${this.data.clickable ? klass.pointer : ''}">
        ${this.data.is_partner ? IconBasicGuarantee : ''}
      </div>
    </div> `;
  }
}
